import React from "react";
import "./Error.css";
const Error = () => {
  return (
    <div className="error">
      <h1>404</h1>
    </div>
  );
};

export default Error;
